import { EvComboboxOption, IFilterDefinition, IFilterValues } from '@evinced-private/ui-common';

import { IFilterOptions } from '../../../components/data-filter/DataFilterHelper';
import GlobeIcon from '../../../components/icons/Globe.svg?raw';
import UserIcon from '../../../components/icons/User.svg?raw';
import { CollectionTypeLabels, CollectionTypes, ICollection } from '../../../interfaces/Collection';

export const PROPERTIES_PAGE_FILTERS_ID = 'properties-page-filters';

export const defaultFilterValues: IFilterOptions = {
	searchValue: '',
	collections: []
};

export const getFilterDefinitions = (
	isMultipleCollectionsEnabled: boolean
): IFilterDefinition[] => {
	const filterDefinitions: IFilterDefinition[] = [
		{
			id: 'searchValue',
			label: 'Search',
			filterType: 'text',
			defaultValue: '',
			componentProps: { className: 'search-filter', placeholder: 'Search properties' }
		}
	];

	// condition should be removed when multiple collections feature is fully integrated
	if (isMultipleCollectionsEnabled) {
		filterDefinitions.push({
			id: 'collections',
			label: 'Select Collections',
			filterType: 'select',
			defaultValue: [],
			componentProps: {
				id: 'collections',
				label: 'Collections',
				isMultiple: true,
				placeholder: 'Select Collections',
				listboxWidth: '288px',
				allSelectedPlaceholder: 'All Collections',
				someItemsSelectedText: (count: number) => `Collections (${count})`,
				className: 'collections-filter',
				groups: [
					{
						id: CollectionTypes.USER,
						name: CollectionTypeLabels.USER,
						icon: UserIcon
					},
					{
						id: CollectionTypes.TENANT,
						name: CollectionTypeLabels.TENANT,
						icon: GlobeIcon
					}
				]
			}
		});
	}

	return filterDefinitions;
};

export const getInitialFilterValues = ({
	appliedFilters,
	propertyCollections,
	isCollectionsLoading
}: {
	appliedFilters?: IFilterOptions;
	propertyCollections?: ICollection[];
	isCollectionsLoading?: boolean;
}): IFilterValues => {
	if (isCollectionsLoading) {
		return {
			text: { searchValue: appliedFilters?.searchValue || '' },
			select: { collections: appliedFilters?.collections || [] }
		};
	}

	// Removing non-existent collections from filters
	const collectionsForFilters = appliedFilters?.collections?.filter((filterCollection) => {
		return !!propertyCollections.find((collection) => collection.id === filterCollection.value);
	});

	return {
		text: { searchValue: appliedFilters?.searchValue || '' },
		select: {
			collections: collectionsForFilters || []
		}
	};
};

export const mapCollectionsToOptions = (collections: ICollection[]): EvComboboxOption[] => {
	if (!collections || !collections?.length) {
		return [];
	}

	return collections.map((collection) => ({
		label: collection.name,
		value: collection.id,
		groupId: collection.type
	}));
};
